export const mapLevelTypes = {
  SOURCE: 0,
  DESTINATION: 1,
  SUBMIT: 2,
  SUBMIT_FINAL: 3,
  SUBMIT_ADVANCED: 4,
};

const mapTypes = {
  SET_CENTEROFMAP: "SET_CENTEROFMAP",

  FETCH_CENTEROFMAPADDRESS_START: "FETCH_CENTEROFMAPADDRESS_START",
  FETCH_CENTEROFMAPADDRESS_SUCCESS: "FETCH_CENTEROFMAPADDRESS_SUCCESS",

  FETCH_ADDRESSSUGGESTIONS_START: "FETCH_ADDRESSSUGGESTIONS_START",
  FETCH_ADDRESSSUGGESTIONS_SUCCESS: "FETCH_ADDRESSSUGGESTIONS_SUCCESS",

  TOGGLE_MAPLEFTOVERLAY_SHOW: "TOGGLE_MAPLEFTOVERLAY_SHOW",

  SET_MAP_LEVEL: "SET_MAP_LEVEL",
  SET_SUGGESTIONS_SHOW: "SET_SUGGESTIONS_SHOW",

  INCREASE_MAP_LEVEL: "INCREASE_MAP_LEVEL",
  DECREASE_MAP_LEVEL: "DECREASE_MAP_LEVEL",

  SET_BOTTOMWHITE_LONG: "SET_BOTTOMWHITE_LONG",

  SET_GOLEVEL_4: "SET_GOLEVEL_4",

  SET_SOURCELOCATION_JUSTSET: "SET_SOURCELOCATION_JUSTSET",
};

export default mapTypes;
